import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RedirectNoParams = () => {
  const location = useLocation();

  useEffect(() => {
    const redirectUrl = `https://old.transparent.utah.gov/state_rvex.php`;
    console.log(`Redirecting to: ${redirectUrl}`);
    window.location.replace(redirectUrl);
  }, [location]);

  return (
    <>
    </>
  )
}

export default RedirectNoParams;